import React from 'react'
const Notfound = () => <h1>404 Not Found</h1>
export default Notfound